export default "__VITE_ASSET__BJQzaOTt__"